export function PageBanner({ image, overline, title, subtitle, actions, height = "h-48" }) {
  return (
    <div className={`relative rounded-xl overflow-hidden ${height} flex items-end`} data-testid="page-banner">
      <img src={image} alt="" className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0" style={{ background: "linear-gradient(90deg,#050505 8%,rgba(5,5,5,0.45) 65%,rgba(5,5,5,0.05))" }} />
      <div className="absolute inset-0" style={{ background: "linear-gradient(0deg,#050505,transparent 55%)" }} />
      <div className="relative p-6 md:p-8 w-full flex flex-wrap items-end justify-between gap-4">
        <div>
          {overline && <span className="mono-label text-acid">{overline}</span>}
          <h1 className="font-heading font-black text-3xl md:text-4xl tracking-tight mt-1">{title}</h1>
          {subtitle && <p className="text-[#B7BECB] mt-2 max-w-xl text-sm">{subtitle}</p>}
        </div>
        {actions}
      </div>
    </div>
  );
}
